export default __webpack_public_path__ + "static/media/(10).c3cc6dac.JPG";